import { useDeleteProjectMutation } from '@api/projects';

const useDeleteProject = () => {
  const [deleteProject, { isLoading, isSuccess }] = useDeleteProjectMutation();

  const userDeleteProject = async (id: string) => {
    try {
      await deleteProject(id).unwrap();
    } catch (err) {
      console.log(err);
    }
  };

  return {
    userDeleteProject,
    isDeleting: isLoading,
    isDeleteSuccess: isSuccess
  };
};

export default useDeleteProject;
